<template id="loading">
  <div class="loading-full-screen">
    <div class="animation-box">
      <lottie :options="defaultOptions" :height="50" :width="50" />
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie';
import animationData from '../assets/lottie/indeterminate_basic_white.json';

export default {
  name: 'Loading',
  components: {
    Lottie,
  },
  props: [
  ],
  data() {
    return {
      defaultOptions: {
        animationData,
        loop: true,
        autoplay: true,
      },
    };
  },
  methods: {
  },
  template: '#loading',
};
</script>
